// Specializaion
import { subGroup, route, meta } from '@/helpers/routes'
import Index from './index/index'

const routes = [
  route('index', '/index', Index, meta('Política de Privacidade', true, 'guest'))
]

export default subGroup('/patient/policy', routes)



// WEBPACK FOOTER //
// ./src/app/patient/privacy-policy/routes.js